import { IonButton, IonButtons, IonCol, IonGrid, IonIcon, IonItem, IonRow } from '@ionic/react'
import { trashOutline } from 'ionicons/icons'
import React, { useState } from 'react'
import { IShowPhotoViewerProps } from '../../attachments/page/Attachments.page'
import { PhotoViewer } from '@capacitor-community/photoviewer'
import SInput from '../../../components/stringInput/StringInput.component'
import SingleSelect from '../../../components/singleSelect/SingleSelect.component'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getCameraAttachmentsOptionsSelector } from '../../options/selectors'
import { IOption } from '../../../common/common.types'

export interface DocumentItemProps {
  documentId: string
  imageSource: string
  onDocumentEditName: (id: string, name: string) => void
  onDocumentEditCategory: (id: string, category: IOption | null) => void
  onDocumentDelete: (id: string) => void
}

const DocumentItem = (props: DocumentItemProps) => {
  const { documentId, imageSource, onDocumentEditName, onDocumentEditCategory, onDocumentDelete } = props

  const { t } = useTranslation()

  const [name, setName] = useState<string>('')
  const [category, setCategory] = useState<IOption | null>(null)

  const cameraAttachmentsOptionsState = useSelector(getCameraAttachmentsOptionsSelector)
  const { categoryOptions } = cameraAttachmentsOptionsState

  const showPhotoViewer = (photoViewerProps: IShowPhotoViewerProps) => {
    const { src, alt } = photoViewerProps

    PhotoViewer.show({
      images: [
        {
          url: src || '',
          title: alt,
        },
      ],
      options: {
        share: false,
      },
    })
  }

  const setNameOnChange = (e: CustomEvent) => {
    e.preventDefault()
    setName(e.detail.value)
    onDocumentEditName(documentId, e.detail.value)
  }

  const setCategoryOnChange = (option: IOption) => {
    setCategory(option)
    onDocumentEditCategory(documentId, option)
  }

  const handleDocumentDelete = () => {
    onDocumentDelete(documentId)
  }

  const renderDocumentFields = () => {
    return (
      <>
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('cameraAttachments.name')}
              dataTestID='ImageName'
              inputValue={name}
              onChangeAction={setNameOnChange}
              maxlength={250}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='ImageCategory'
              options={categoryOptions}
              selectedOption={category}
              listHeader={t('cameraAttachments.category')}
              label={t('cameraAttachments.category')}
              action={setCategoryOnChange}
            />
          </IonCol>
        </IonRow>
      </>
    )
  }

  return (
    <IonItem className='document-item-wrapper' lines='none'>
      <IonGrid className='document-item-grid'>
        <IonRow>
          <IonCol>
            <div className='document-item'>
              <div className='document-item-thumbnail'>
                <img
                  src={`data:image/png;base64,${imageSource}`}
                  alt={`scanned-document-${documentId}`}
                  className='document-item-img'
                  onClick={() => {
                    showPhotoViewer({
                      src: `data:image/png;base64,${imageSource}`,
                      alt: `scanned-document-${documentId}`,
                    })
                  }}
                />
              </div>
              <IonButtons className='document-item-delete'>
                <IonButton data-testid='delete' onClick={handleDocumentDelete}>
                  <IonIcon color='medium' icon={trashOutline} className='document-item-delete-icon' />
                </IonButton>
              </IonButtons>
            </div>
          </IonCol>
        </IonRow>
        {renderDocumentFields()}
      </IonGrid>
    </IonItem>
  )
}

export default DocumentItem
